import React from 'react'
import { Redirect } from 'react-router-dom'
import config from '../config'

export default function Logout () {
  localStorage.removeItem(config.localStorage.oauthIDToken)
  localStorage.removeItem(config.localStorage.oauthRefreshToken)
  return <Redirect to='/home' />
}
